import { useAppSelector } from '@/main/app/hooks/storeHooks'
import { selectItemsByListId } from '@/main/features/Item/itemSlice'

import type { ListId } from '../../listSlice'

import { ListSubtotal } from '../ListSubtotal/ListSubtotal'
import { Tooltip } from '@/main/components/Tooltip/Tooltip'
import { Question } from '@phosphor-icons/react'

export function ListSummary({ listId }: { listId?: ListId }) {
  const items = useAppSelector((state) => selectItemsByListId(state, listId))
  const count = items.reduce((sum, item) => item.count + sum, 0)

  return (
    <dl className="twc-divide-y dark:twc-divide-slate-800 dark:twc-text-gray-100">
      <div className="twc-flex twc-justify-between twc-py-2">
        <dt>Props in cart:</dt>
        <dd>{items.length}</dd>
      </div>
      <div className="twc-flex twc-justify-between twc-py-2">
        <dt>Total quantity:</dt>
        <dd>{count}</dd>
      </div>
      <div className="twc-flex twc-justify-between twc-py-2">
        <dt className="twc-inline-flex">
          <span>Rental estimate: </span>
          <Tooltip
            align="center"
            title="Estimate info"
            icon={
              <>
                <Question weight="bold" size={16} />
              </>
            }
          >
            <span className="twc-text-xs xs:twc-text-sm">
              Estimate for (1) rental period. This is not a quote. Submit your cart to get a quote
              with availability.
            </span>
          </Tooltip>
        </dt>
        <dd>
          <ListSubtotal listId={listId} />
        </dd>
      </div>
    </dl>
  )
}
